module.exports = __webpack_public_path__ + "static/media/covid_19_ch.53249f67.jpg";